import React from 'react'
import * as R from 'ramda'

export const useContext = <T>(ctxt: React.Context<T>): T => {
  if (R.isNil(ctxt)) {
    throw new Error('Context was not provided!')
  }

  const context = React.useContext(ctxt)

  return context
}
